import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Sintomatologia from './Sintomatologia';
import SeguimientoMedico from './SeguimientoMedico';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ScrollTabsPanel({ idRegistro, informacionGeneral, idEmpleado, sintomas, permisos, modoCrea, successSubmitCallback, showProgramarPrueba, reloadModal }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Síntomas" {...a11yProps(0)} />
          <Tab label="Seguimiento covid" {...a11yProps(1)} disabled={!permisos?.PuedeVerSeguimiento} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Sintomatologia
          idRegistro={idRegistro}
          idEmpleado={idEmpleado}
          sintomas={sintomas}
          permisos={permisos}
          modoCrea={modoCrea}
          successSubmitCallback={successSubmitCallback}
          informacionGeneral={informacionGeneral}
          reloadModal={reloadModal}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SeguimientoMedico
          idRegistro={idRegistro}
          informacionGeneral={informacionGeneral}
          successSubmitCallback={successSubmitCallback}
          showProgramarPrueba={showProgramarPrueba}
          permisos={permisos}
        />
      </TabPanel>
    </div>
  );
}